<template>
<div class="vert-slider" :class="color">
    <div class="images-container">
        <div class="swiper-container" ref="slider">
        <div class="swiper-wrapper">
            <div v-for="(item, index) in sliderItems" v-bind:key="index" class="swiper-slide">
                <img :src="item.image ? item.image.url : '/svg/image_placeholder.svg'" :alt="item.image ? item.image.alt : 'Platzhalter'">
            </div>
        </div>
    </div>
    </div>
    <div class="controls-container">
        <div class="controls">
            <svg @click="previousSlide" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m176.907 256 30.186-30.187L109.28 128l97.813-97.813L176.907 0l-128 128z"/></svg>
            <div class="line"></div>
            <div class="pages">
                {{ pad(this.currentItemIndex + 1, 2) }}&nbsp;/&nbsp;{{ pad(this.sliderItems.length, 2) }}
            </div>
            <svg @click="nextSlide" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><path fill="currentColor" d="M79.093 0 48.907 30.187 146.72 128l-97.813 97.813L79.093 256l128-128z"/></svg>
        </div>
    </div>
    <div class="text-container">
        <slot></slot>
    </div>
</div>
</template>

<script>
import Swiper from 'swiper';

export default {
    props: {
        items: String,
        color: String,
    },
    data() {
        return {
            currentItemIndex: 0,
            sliderItems: JSON.parse(this.items) ?? {},
            swiper: null,
        };
    },
    watch: {
        currentItemIndex(val) {
			this.$eventHub.$emit('updateVertItemIndex', val, this);
            this.swiper.slideTo(val);
        }
    },
    methods: {
        pad: (number, digits) => {
			number = String(number);
			return number.length >= digits ? number : new Array(digits - number.length + 1).join('0') + number;
		},
        previousSlide() {
			this.currentItemIndex = (this.currentItemIndex > 0) ? this.currentItemIndex - 1 : this.sliderItems.length - 1;
		},
		nextSlide() {
			this.currentItemIndex = (this.currentItemIndex < this.sliderItems.length - 1) ? this.currentItemIndex + 1 : 0;
		},
    },
    mounted() {
        let context = this;

        this.swiper = new Swiper(this.$refs.slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            direction: 'horizontal',
            centeredSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 60,
                },
                1280: {
                    slidesPerView: 3,
                    direction: 'vertical',
                    spaceBetween: 80,
                }
            },
            on: {
                slideChange: (swiper) => {
                    context.currentItemIndex = swiper.realIndex;
                }
            }
        });
    }
}
</script>
